import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: erstoria;
  color: #253569;
  background-color: rgb(255, 254, 239);
  text-align: center;

  font-size: 2em;
  @media (max-width: 1080px) {
    font-size: 1.6em;
  }

  @media (max-width: 640px) {
    font-size: 1.3em;
  }

  @media (max-width: 400px) {
    font-size: 1.1em;
    height: 80vh;
  }

  margin: 0;
  margin-bottom: 100px;
  padding-top: 100px;
  padding-bottom: 100px;

  position: relative;

  &:before {
    position: absolute;
    top: 0;
    border-top: 2px solid #253569;
    width: 60%;
    content: "";
  }

  &:after {
    position: absolute;
    bottom: 0;
    border-top: 2px solid #253569;
    width: 60%;
    content: "";
  }
`;

const Paragraph = styled.p`
  line-height: 1.2em;
  font-family: erstoria;
  margin: 0;
  padding: 0;
  margin-bottom: 40px;
`;

const Bio = () => {
  return (
    <Wrapper>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "70%",
        }}
      >
        <Paragraph>
          I am a London-based freelance digital content and communications
          specialist with a background in production coordination, film
          outreach, and publicity.
        </Paragraph>
        <Paragraph>
          I have created case studies and branded content as a video and podcast
          editor for international charities, nonprofits, and commercial
          clients.
        </Paragraph>
        <Paragraph>
          I have also directed and edited short documentaries including the
          award-winning <em>Happy Naked People</em> and{" "}
          <em>All to Play For (Todo por jugar)</em>, which was broadcast on
          Barcelona's public TV channel Betevé in 2020 and 2021.
        </Paragraph>
      </div>
    </Wrapper>
  );
};

export default Bio;
